import { sendPost } from "src/utils/sendApi";

export const reportUpload = sendPost("v1/data/upload_report");

export const reportSharing = sendPost("v1/data/share_report");

export const reportDeletion = sendPost("v1/data/delete_report");

export const reportsRetrieve = sendPost("v1/data/retrieve_reports")